import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, EventEmitter, Input, Output, HostBinding, Directive, NgModule } from '@angular/core';
import * as i2 from 'se-fe-button';
import { SeFeButtonModule } from 'se-fe-button';
import * as i3 from 'se-fe-spinner';
import { SeFeSpinnerModule } from 'se-fe-spinner';
import * as i5 from '@angular/cdk/a11y';
import { A11yModule } from '@angular/cdk/a11y';

class StylesComponent {
}
StylesComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: StylesComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
StylesComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: StylesComponent, selector: "styles", ngImport: i0, template: '', isInline: true, styles: [".se-fe-side-panel__actions se-fe-icon-button.se-fe-button--low button{color:#fff!important}.se-fe-side-panel__header-content se-fe-header .se-fe-header{align-items:flex-start}.se-fe-side-panel__header-content se-fe-header .se-fe-header .se-fe-header__visual se-fe-avatar{margin:-32px 0 -16px -4px}.se-fe-side-panel__header-content .se-fe-header__text-and-actions .se-fe-header__text .se-fe-header__title{font-size:calc(var(--se-rem, 1rem) * 1.7142857143)}.se-fe-side-panel__header-content .se-fe-header__text-and-actions .se-fe-header__text .se-fe-header__subtitle{font-size:calc(var(--se-rem, 1rem) * 1)}@media (max-width: 599px){.se-fe-side-panel__header-content se-fe-header .se-fe-header .se-fe-header__visual se-fe-avatar{margin:-16px 0 -12px -2px}.se-fe-side-panel__header-content .se-fe-header__text-and-actions .se-fe-header__text .se-fe-header__title{font-size:calc(var(--se-rem, 1rem) * 1.4285714286)}.se-fe-side-panel__header-content .se-fe-header__text-and-actions .se-fe-header__text .se-fe-header__subtitle{font-size:calc(var(--se-rem, 1rem) * 1)}}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: StylesComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'styles',
                    template: '',
                    styleUrls: ['./styles.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                }]
        }] });

class SeFeSidePanelComponent {
    constructor(el) {
        this.el = el;
        this.wrapperTabindex = '0';
        this.headerId = `se-fe-header-${Date.now()}-${SeFeSidePanelComponent.counter++}`;
        this.loaded = true;
        this.visible = false;
        this.seFeDataVisibleChange = new EventEmitter();
        this.seFeClose = new EventEmitter();
        this.baseClass = true;
        this.outsideClick = (evt) => {
            const path = evt.composedPath();
            const trigger = evt.target.closest(`[sefesidepaneltrigger]`);
            if (!path.includes(this.el.nativeElement) && this.visible && !trigger)
                this.close();
        };
        this.onEscape = (evt) => {
            if (evt.code === 'Escape' && this.visible)
                this.close();
        };
        //noop
    }
    ngOnChanges(changes) {
        if (changes.visible) {
            if (this.visible) {
                this.wrapperTabindex = '0';
                setTimeout(() => {
                    document.addEventListener('click', this.outsideClick);
                    document.addEventListener('keyup', this.onEscape);
                });
            }
            else {
                document.removeEventListener('click', this.outsideClick);
                document.removeEventListener('keyup', this.onEscape);
            }
        }
    }
    get loadedClass() { return this.loaded; }
    get visibleClass() { return this.visible; }
    close() {
        this.visible = false;
        this.seFeDataVisibleChange.emit(false);
        this.seFeClose.emit();
    }
    ngOnDestroy() {
        document.removeEventListener('click', this.outsideClick);
        document.removeEventListener('keyup', this.onEscape);
    }
}
SeFeSidePanelComponent.counter = 1;
SeFeSidePanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeSidePanelComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
SeFeSidePanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeSidePanelComponent, selector: "se-fe-side-panel", inputs: { loaded: ["seFeDataLoaded", "loaded"], visible: ["seFeDataVisible", "visible"] }, outputs: { seFeDataVisibleChange: "seFeDataVisibleChange", seFeClose: "seFeClose" }, host: { properties: { "class.se-fe-side-panel": "this.baseClass", "class.se-fe-side-panel--loaded": "this.loadedClass", "class.se-fe-side-panel--visible": "this.visibleClass" } }, usesOnChanges: true, ngImport: i0, template: "<styles></styles>\n<div\n  *ngIf=\"visible\"\n  role=\"region\"\n  class=\"se-fe-side-panel__wrapper\"\n  [attr.aria-labelledby]=\"headerId\"\n  cdkTrapFocus\n  cdkTrapFocusAutoCapture=\"true\"\n  [attr.tabindex]=\"wrapperTabindex\"\n  (blur)=\"wrapperTabindex = '-1'\">\n  <div class=\"se-fe-side-panel__header\" >\n    <div class=\"se-fe-side-panel__actions\">\n      <ng-content select=\"[seFeSidePanelActions]\"></ng-content>\n      <se-fe-icon-button (click)=\"close()\">\n        <svg class=\"se-fe-side-panel__close\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" preserveAspectRatio=\"xMidYMid meet\">\n          <title>Close</title>\n          <path stroke-width=\"0\" d=\"M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z\"/>\n        </svg>\n      </se-fe-icon-button>\n    </div>\n    <div *ngIf=\"loaded\" class=\"se-fe-side-panel__header-content\" [attr.id]=\"headerId\">\n      <ng-content select=\"[seFeSidePanelHeader]\"></ng-content>\n    </div>\n  </div>\n  <div class=\"se-fe-side-panel__content\">\n    <div *ngIf=\"!loaded\" class=\"se-fe-side-panel__spinner\">\n      <se-fe-spinner [seFeDataSize]=\"900\"></se-fe-spinner>\n    </div>\n    <div *ngIf=\"loaded && visible\">\n      <ng-content select=\"[seFeSidePanelContent]\"></ng-content>\n    </div>\n  </div>\n  <ng-content select=\"[seFeSidePanelOverlay]\"></ng-content>\n</div>\n\n", styles: [":host{background:#f2f3f4;color:#23282b;display:flex;flex-direction:column;height:100vh;max-width:100%;overflow-x:hidden;overflow-y:auto;overscroll-behavior:contain;position:fixed;right:0;top:0;transform:translate(100%);transition:transform .5s cubic-bezier(.25,1,.5,1);width:100%;z-index:99}:host.se-fe-side-panel--visible{box-shadow:0 1px 5px #0003,0 3px 4px #0000001f,0 2px 4px #00000024;transform:none}@media (min-width: 600px){:host{max-width:1008px;width:66.66%}}.se-fe-side-panel__header{display:block;font:normal 400 calc(var(--se-rem, 1rem) * 1)/1.4286 \"Open Sans\",sans-serif;position:sticky;top:0;z-index:10;padding-top:.05px}.se-fe-side-panel__header-content{flex:1 1 100%;background:white;padding:12px 28px 28px 44px;box-shadow:0 1px 5px #0003,0 3px 4px #0000001f,0 2px 4px #00000024}.se-fe-side-panel__actions{display:flex;align-items:center;justify-content:flex-end;padding:8px 12px;background:linear-gradient(90deg,#0e3d62,#1b87c8)}.se-fe-side-panel__close{fill:#fff;flex:0 0 auto;height:28px;width:28px}.se-fe-side-panel__content{flex:1 1 100%;padding:24px;position:relative}.se-fe-side-panel__spinner{align-items:center;display:flex;justify-content:center}@media (max-width: 599px){.se-fe-side-panel__header-content{padding:8px 18px 18px 24px}.se-fe-side-panel__actions{padding:0 8px}.se-fe-side-panel__content{padding:12px}}\n"], components: [{ type: StylesComponent, selector: "styles" }, { type: i2.SeFeIconButtonComponent, selector: "se-fe-icon-button", inputs: ["seFeDataIsDisabled", "seFeDataIsLoading", "seFeDataIndicatorDot", "seFeDataIndicatorDotColor", "seFeDataLoadingLabel"] }, { type: i3.SeFeSpinnerComponent, selector: "se-fe-spinner", inputs: ["seFeDataSize", "seFeDataInverted", "seFeDataCenter", "seFeDataAriaLabel"] }], directives: [{ type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeSidePanelComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-side-panel',
                    templateUrl: './se-fe-side-panel.component.html',
                    styleUrls: ['./se-fe-side-panel.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { loaded: [{
                type: Input,
                args: ['seFeDataLoaded']
            }], visible: [{
                type: Input,
                args: ['seFeDataVisible']
            }], seFeDataVisibleChange: [{
                type: Output
            }], seFeClose: [{
                type: Output
            }], baseClass: [{
                type: HostBinding,
                args: ['class.se-fe-side-panel']
            }], loadedClass: [{
                type: HostBinding,
                args: ['class.se-fe-side-panel--loaded']
            }], visibleClass: [{
                type: HostBinding,
                args: ['class.se-fe-side-panel--visible']
            }] } });

class SeFeSidePanelTriggerDirective {
    constructor() {
        this._visible = false;
    }
    ngOnChanges(changes) {
        if (changes._visible) {
            if (this._visible) {
                const element = document.querySelector('.se-fe-side-panel--visible .se-fe-side-panel__wrapper');
                setTimeout(() => {
                    var _a;
                    (_a = element) === null || _a === void 0 ? void 0 : _a.focus();
                });
            }
        }
    }
    get visible() {
        return this._visible;
    }
}
SeFeSidePanelTriggerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeSidePanelTriggerDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
SeFeSidePanelTriggerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: SeFeSidePanelTriggerDirective, selector: "seFeSidePanelTrigger, [seFeSidePanelTrigger]", inputs: { _visible: ["seFeSidePanelTrigger", "_visible"] }, host: { properties: { "attr.seFeSidePanelTrigger": "this.visible", "attr.aria-expanded": "this.visible" } }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeSidePanelTriggerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'seFeSidePanelTrigger, [seFeSidePanelTrigger]'
                }]
        }], propDecorators: { _visible: [{
                type: Input,
                args: ['seFeSidePanelTrigger']
            }], visible: [{
                type: HostBinding,
                args: ['attr.seFeSidePanelTrigger']
            }, {
                type: HostBinding,
                args: ['attr.aria-expanded']
            }] } });

class SeFeSidePanelModule {
}
SeFeSidePanelModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeSidePanelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeSidePanelModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeSidePanelModule, declarations: [SeFeSidePanelComponent,
        SeFeSidePanelTriggerDirective,
        StylesComponent], imports: [CommonModule,
        A11yModule,
        SeFeButtonModule,
        SeFeSpinnerModule], exports: [SeFeSidePanelComponent, SeFeSidePanelTriggerDirective] });
SeFeSidePanelModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeSidePanelModule, imports: [[
            CommonModule,
            A11yModule,
            SeFeButtonModule,
            SeFeSpinnerModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeSidePanelModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SeFeSidePanelComponent,
                        SeFeSidePanelTriggerDirective,
                        StylesComponent
                    ],
                    imports: [
                        CommonModule,
                        A11yModule,
                        SeFeButtonModule,
                        SeFeSpinnerModule,
                    ],
                    exports: [SeFeSidePanelComponent, SeFeSidePanelTriggerDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SeFeSidePanelComponent, SeFeSidePanelModule, SeFeSidePanelTriggerDirective };
